<div class="max-w-[1320px] mx-auto px-6 lg:px-10 py-10 animate-fade-in relative z-10 pb-24">

  <!-- Header -->
  <div class="mb-10">
    <h1 class="font-display font-black text-[36px] md:text-[44px] text-white tracking-wide mb-2">Staking</h1>
    <p class="text-[14px] text-text-muted mb-4">Deposit WETH, BNB, or POL into the staking pool to earn rewards of 9.5% APY,
      with rewards claimable at any time.</p>
    <div class="mt-6 p-4 rounded-xl bg-gold/10 border border-gold/30 flex items-start gap-3">
      <svg class="w-5 h-5 text-gold flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <p class="text-white text-[13.5px] leading-relaxed">
        <span class="font-bold text-gold">Important Note:</span> Staking fees on DEX are higher than most DEX's because the rates for the flex 30D and 90D rates are generated from our own active DEX LP's that are earning daily compounding fees in established liquidity pools
      </p>
    </div>
  </div>

  <!-- Top Stats Row -->
  <div class="grid grid-cols-1 tablet:grid-cols-2 desktop:grid-cols-4 gap-4 mb-8">
    <!-- Stat 1 -->
    <div
      class="bg-[#0c0c0c]/80 border border-white/[0.05] shadow-[0_12px_45px_rgba(0,0,0,0.4)] rounded-[16px] p-6 backdrop-blur-xl">
      <div class="flex items-center gap-3 text-text-muted mb-4">
        <svg class="w-5 h-5 text-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
        </svg>
        <span class="text-[13px] font-bold">Total Value Staked</span>
      </div>
      <div class="text-[26px] font-black text-white mb-2 tracking-tight">
        <ng-container *ngIf="isLoadingLiveStats">
          <div class="h-8 bg-white/10 rounded animate-pulse w-32 mt-1"></div>
        </ng-container>
        <ng-container *ngIf="!isLoadingLiveStats">
          ${{formatNumber(globalStats.totalValueStaked)}}
        </ng-container>
      </div>
    </div>

    <!-- Stat 2 -->
    <div
      class="bg-[#0c0c0c]/80 border border-white/[0.05] shadow-[0_12px_45px_rgba(0,0,0,0.4)] rounded-[16px] p-6 backdrop-blur-xl">
      <div class="flex items-center gap-3 text-text-muted mb-4">
        <svg class="w-5 h-5 text-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
        <span class="text-[13px] font-bold">Average APY</span>
      </div>
      <div class="text-[26px] font-black text-white mb-2 tracking-tight">
        <ng-container *ngIf="isLoadingLiveStats">
          <div class="h-8 bg-white/10 rounded animate-pulse w-24 mt-1"></div>
        </ng-container>
        <ng-container *ngIf="!isLoadingLiveStats">
          {{formatNumber(globalStats.avgApr)}}%
        </ng-container>
      </div>
    </div>

    <!-- Stat 3 -->
    <div
      class="bg-[#0c0c0c]/80 border border-white/[0.05] shadow-[0_12px_45px_rgba(0,0,0,0.4)] rounded-[16px] p-6 backdrop-blur-xl">
      <div class="flex items-center gap-3 text-text-muted mb-4">
        <svg class="w-5 h-5 text-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
        <span class="text-[13px] font-bold">Active Stakers</span>
      </div>
      <div class="text-[26px] font-black text-white mb-2 tracking-tight">{{globalStats.activeStakers.toLocaleString()}}
      </div>
      <div class="flex items-center gap-2 text-[12.5px] font-bold">
        <span class="text-[#20d489] flex items-center gap-1"><svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg> Growing</span>
        <span class="text-text-dim">total users</span>
      </div>
    </div>

    <!-- Stat 4 -->
    <div
      class="bg-[#0c0c0c]/80 border border-white/[0.05] shadow-[0_12px_45px_rgba(0,0,0,0.4)] rounded-[16px] p-6 backdrop-blur-xl">
      <div class="flex items-center gap-3 text-text-muted mb-4">
        <svg class="w-5 h-5 text-gold" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
        </svg>
        <span class="text-[13px] font-bold">Total Pools</span>
      </div>
      <div class="text-[26px] font-black text-white mb-2 tracking-tight">{{globalStats.totalPools}}</div>
      <div class="flex items-center gap-2 text-[12.5px] font-bold">
        <span class="text-text-dim">Active right now</span>
      </div>
    </div>
  </div>

  <!-- Connect Wallet CTA -->
  @if (!state.isWalletConnected()) {
  <div
    class="bg-[#0c0c0c]/80 border border-white/[0.05] shadow-[0_12px_45px_rgba(0,0,0,0.4)] rounded-[16px] p-6 backdrop-blur-xl flex flex-col md:flex-row items-center justify-between gap-6 mb-12">
    <div class="flex items-center gap-5">
      <div class="w-12 h-12 rounded-xl bg-gold/10 border border-gold/20 flex items-center justify-center text-gold">
        <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
        </svg>
      </div>
      <div>
        <div class="text-[16px] font-bold text-white mb-1">Connect your wallet to start staking</div>
        <div class="text-[13.5px] text-text-muted">Stake your tokens and start earning rewards.</div>
      </div>
    </div>
    <button (click)="state.openConnectModal()"
      class="btn-gold py-3 px-8 rounded-[12px] font-bold text-[14px] w-full md:w-auto tracking-wide">CONNECT
      WALLET</button>
  </div>
  }

  <!-- My Stakes Section -->
  @if (state.isWalletConnected()) {
  <div class="mb-12">
    <h2 class="text-[22px] font-bold text-white mb-6">My Active Stakes</h2>

    @if (isStakesLoading && userStakes.length === 0) {
    <div class="flex items-center justify-center py-10">
      <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-gold"></div>
    </div>
    } @else if (userStakes.length === 0) {
    <div class="bg-[#050505]/90 border border-white/[0.05] rounded-[20px] p-8 text-center">
      <svg class="w-12 h-12 text-text-dim mx-auto mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="1.5">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
      <h3 class="text-[16px] font-bold text-white mb-1">No Active Stakes</h3>
      <p class="text-[13px] text-text-muted">You haven't staked any tokens yet. Or your transaction is still syncing
        with the network.</p>
    </div>
    } @else {
    <div class="flex flex-col relative w-full overflow-hidden">
      @if (isStakesLoading) {
      <div
        class="absolute inset-0 z-10 flex items-center justify-center bg-[#050505]/50 backdrop-blur-sm rounded-[20px]">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gold"></div>
      </div>
      }

      <!-- Table Header (Desktop) -->
      <div
        class="hidden md:grid grid-cols-5 gap-4 px-6 py-3 border-b border-white/[0.04] text-[12px] font-bold text-text-dim uppercase tracking-wider mb-2">
        <div class="col-span-2">Asset</div>
        <div class="col-span-1">Staked Amount</div>
        <div class="col-span-1">Pending Rewards</div>
        <div class="col-span-1 text-right pr-2">Action</div>
      </div>

      <div *ngFor="let stake of userStakes"
        class="grid grid-cols-1 md:grid-cols-5 gap-4 px-6 py-5 border-b border-white/[0.02] hover:bg-white/[0.02] transition-colors items-center group relative">

        <!-- Asset -->
        <div class="col-span-1 md:col-span-2 flex items-center gap-3">
          <div
            class="w-10 h-10 rounded-full border-[2px] border-[#0c0c0c] flex items-center justify-center text-white shadow-md relative"
            [style.background]="stake.pool.logoUrl ? 'transparent' : stake.pool.color">
            @if (stake.pool.logoUrl) {
            <img [src]="stake.pool.logoUrl" class="w-full h-full rounded-full object-cover">
            } @else {
            <span class="text-[13px] font-bold">{{stake.pool.tokenName.charAt(0) || 'U'}}</span>
            }
            <div *ngIf="stake.pool.rewardTokenLogo"
              class="absolute -bottom-1 -right-1 w-4 h-4 rounded-full border border-[#0c0c0c] flex items-center justify-center bg-transparent">
              <img [src]="stake.pool.rewardTokenLogo" class="w-full h-full rounded-full object-cover">
            </div>
            <div *ngIf="!stake.pool.rewardTokenLogo"
              class="absolute -bottom-1 -right-1 w-4 h-4 rounded-full border border-[#0c0c0c] flex items-center justify-center text-[8px] font-bold text-white"
              [style.background]="stake.pool.color">{{(stake.pool.rewardToken || 'R').charAt(0)}}</div>
          </div>
          <div>
            <div class="text-[15px] font-bold text-white">{{stake.pool.name || 'Unknown Staking'}}</div>
            <div class="text-[12px] text-text-dim">Yield: <span class="text-gold font-bold">{{getStakeApy(stake)}}% APY</span></div>
          </div>
        </div>

        <!-- Staked Amount -->
        <div class="col-span-1 flex flex-row md:flex-col justify-between md:justify-center items-center md:items-start">
          <span class="md:hidden text-[12px] font-bold text-text-dim">Staked</span>
          <span class="text-[14px] font-bold text-white">{{formatSubscript(stake.amount)}} {{stake.pool.tokenName || 'Unknown'}}</span>
        </div>

        <!-- Pending Rewards -->
        <div class="col-span-1 flex flex-row md:flex-col justify-between md:justify-center items-center md:items-start">
          <span class="md:hidden text-[12px] font-bold text-text-dim">Pending</span>
          <span class="text-[15px] font-black text-[#20d489]">{{formatSubscript(stake.pendingReward)}}</span>
          <span class="text-[12px] font-black text-[#20d489] ml-1">{{stake.pool.rewardToken || ''}}</span>
        </div>

        <!-- Actions -->
        <div class="col-span-1 flex justify-end gap-2">
          <button (click)="claimRewards(stake)"
            [disabled]="isClaiming[stake.pool.stakingAddress + '-' + stake.pool.stakingTokenAddress + '-' + stake.depositIndex + '-' + stake._uiId] || hasNoRewards(stake)"
            class="btn-secondary border border-gold/30 text-gold hover:bg-gold/10 px-4 py-2 rounded-xl font-bold text-[11px] transition-colors flex items-center justify-center gap-1 disabled:opacity-50 disabled:hover:bg-transparent disabled:cursor-not-allowed">
            <span *ngIf="isClaiming[stake.pool.stakingAddress + '-' + stake.pool.stakingTokenAddress + '-' + stake.depositIndex + '-' + stake._uiId]"
              class="animate-spin rounded-full h-3 w-3 border-b-2 border-gold"></span>
            {{isClaiming[stake.pool.stakingAddress + '-' + stake.pool.stakingTokenAddress + '-' + stake.depositIndex + '-' + stake._uiId] ? 'CLAIMING' : 'CLAIM'}}
          </button>
          <button (click)="withdraw(stake)"
            [disabled]="isWithdrawing[stake.pool.stakingAddress + '-' + stake.pool.stakingTokenAddress + '-' + stake.depositIndex + '-' + stake._uiId] || isLocked(stake)"
            class="btn-secondary border border-red-500/30 text-red-400 hover:bg-red-500/10 px-4 py-2 rounded-xl font-bold text-[11px] transition-colors flex items-center justify-center gap-1 disabled:opacity-50 disabled:hover:bg-transparent disabled:cursor-not-allowed">
            <span *ngIf="isWithdrawing[stake.pool.stakingAddress + '-' + stake.pool.stakingTokenAddress + '-' + stake.depositIndex + '-' + stake._uiId]"
              class="animate-spin rounded-full h-3 w-3 border-b-2 border-red-400"></span>
            
            <ng-container *ngIf="!isLocked(stake)">
               {{isWithdrawing[stake.pool.stakingAddress + '-' + stake.pool.stakingTokenAddress + '-' + stake.depositIndex + '-' + stake._uiId] ? 'WITHDRAWING' : 'WITHDRAW'}}
            </ng-container>
            <ng-container *ngIf="isLocked(stake)">
               LOCKED ({{getTimeRemaining(stake.lockExpiry)}})
            </ng-container>
          </button>
        </div>
      </div>
    </div>

    <!-- Stakes Pagination -->
    @if (stakesTotal > stakesLimit) {
    <div class="flex items-center justify-center gap-4 mt-8">
      <button (click)="prevStakesPage()" [disabled]="stakesPage === 1"
        class="w-10 h-10 rounded-xl bg-[#111] border border-white/10 flex items-center justify-center text-white disabled:opacity-50 disabled:cursor-not-allowed hover:border-gold/50 transition-colors">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <span class="text-[13px] font-bold text-text-muted">Page {{stakesPage}} of {{Math.ceil(stakesTotal /
        stakesLimit)}}</span>
      <button (click)="nextStakesPage()" [disabled]="stakesPage * stakesLimit >= stakesTotal"
        class="w-10 h-10 rounded-xl bg-[#111] border border-white/10 flex items-center justify-center text-white disabled:opacity-50 disabled:cursor-not-allowed hover:border-gold/50 transition-colors">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
    }
    }
  </div>
  }

  <!-- Staking Pools Section Header -->
  <div class="flex flex-col md:flex-row items-center justify-between gap-4 mb-8">
    <h2 class="text-[24px] font-black tracking-tight text-white flex-1">Staking Pools</h2>
    <div class="flex items-center gap-3 w-full md:w-auto flex-wrap md:flex-nowrap">

      <div class="relative">
        <select [(ngModel)]="sortOption" (ngModelChange)="updateFilteredPools()"
          class="appearance-none bg-[#080808] border border-white/[0.08] rounded-xl py-2.5 pl-4 pr-10 text-[13.5px] font-bold text-white focus:outline-none focus:border-gold/50 cursor-pointer">
          <option value="APY (High to Low)">Sort by: APY (High to Low)</option>
          <option value="APY (Low to High)">Sort by: APY (Low to High)</option>
        </select>
        <svg class="w-4 h-4 absolute right-3.5 top-1/2 -translate-y-1/2 text-text-dim pointer-events-none" fill="none"
          viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  </div>

  @if (isLoading) {
  <div class="flex items-center justify-center py-20">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-gold"></div>
  </div>
  } @else {
  <div class="flex flex-col w-full mb-16 overflow-hidden">
    <!-- Table Header (Desktop) -->
    <div
      class="hidden md:grid grid-cols-5 gap-4 px-6 py-3 border-b border-white/[0.04] text-[12px] font-bold text-text-dim uppercase tracking-wider mb-2">
      <div class="col-span-2">Pool</div>
      <div class="col-span-1">Lock Tiers</div>
      <div class="col-span-1">APY</div>
      <div class="col-span-1 text-right pr-4">Action</div>
    </div>

    <div *ngFor="let pool of filteredPools"
      class="grid grid-cols-1 md:grid-cols-5 gap-4 px-6 py-5 border-b border-white/[0.02] hover:bg-white/[0.02] transition-colors items-center group relative">

      <!-- Pool Info -->
      <div class="col-span-1 md:col-span-2 flex items-center gap-3">
        <div
          class="w-10 h-10 rounded-full flex items-center justify-center text-[13px] font-bold text-white shadow-md relative border-[2px] border-[#0c0c0c]"
          [style.background]="pool.logoUrl ? 'transparent' : pool.color">
          @if (pool.logoUrl) {
          <img [src]="pool.logoUrl" class="w-full h-full rounded-full object-cover">
          } @else {
          <ng-container>{{(pool.tokenName || 'U').charAt(0)}}</ng-container>
          }
          <div *ngIf="pool.rewardTokenLogo"
            class="absolute -bottom-1 -right-1 w-4 h-4 rounded-full border border-[#0c0c0c] flex items-center justify-center bg-transparent">
            <img [src]="pool.rewardTokenLogo" class="w-full h-full rounded-full object-cover">
          </div>
          <div *ngIf="!pool.rewardTokenLogo"
            class="absolute -bottom-1 -right-1 w-4 h-4 rounded-full border border-[#0c0c0c] flex items-center justify-center text-[8px] font-bold text-white"
            [style.background]="pool.color">{{(pool.rewardToken || 'R').charAt(0)}}</div>
        </div>
        <div>
          <div class="text-[15px] font-bold text-white flex items-center gap-2">
            {{pool.name}}
            <div class="px-1.5 py-0.5 rounded-[4px] text-[9px] font-bold tracking-wide uppercase border bg-[#111]"
              [ngClass]="pool.badge === 'Core' ? 'border-gold/30 text-gold' : 'border-[#8247E5]/40 text-[#8247E5] bg-[#8247E5]/10'">
              {{pool.badge}}
            </div>
          </div>
          <div class="text-[12px] text-text-dim">Stake {{pool.tokenName}}, Earn {{pool.rewardToken}}</div>
        </div>
      </div>      <!-- Lock Tiers -->
      <div class="col-span-1 flex flex-row md:flex-col justify-between md:justify-center items-center md:items-start">
        <span class="md:hidden text-[12px] font-bold text-text-dim">Lock Tiers</span>
        <div class="flex flex-col gap-1 mt-1">
          <span *ngFor="let t of pool.lockTiers" class="text-[10px] font-bold text-text-muted border border-white/10 rounded px-1.5 py-0.5 whitespace-nowrap">
            {{t.duration === 0 ? 'Flex' : (t.duration / 86400) + 'D'}}: <span class="text-gold">{{t.apyBps / 100}}% APY</span>
          </span>
          <span *ngIf="!pool.lockTiers?.length" class="text-[13px] font-bold text-text-muted">None</span>
        </div>
      </div>



      <!-- APY -->
      <div class="col-span-1 flex flex-row md:flex-col justify-between md:justify-center items-center md:items-start">
        <span class="md:hidden text-[12px] font-bold text-text-dim">APY</span>
        <span class="text-[15px] font-black text-[#20d489]">{{formatNumber(pool.apy)}}%</span>
      </div>

      <!-- Action -->
      <div class="col-span-1 flex justify-end">
        <button (click)="openStakeModal(pool)"
          class="btn-gold px-6 py-2 rounded-xl text-[12px] font-bold tracking-wider uppercase transition-all duration-200">
          Stake Now
        </button>
      </div>
    </div>
  </div>

  <!-- Pools Pagination -->
  @if (poolsTotal > poolsLimit) {
  <div class="flex items-center justify-center gap-4 mb-16">
    <button (click)="prevPoolsPage()" [disabled]="poolsPage === 1"
      class="w-10 h-10 rounded-xl bg-[#111] border border-white/10 flex items-center justify-center text-white disabled:opacity-50 disabled:cursor-not-allowed hover:border-gold/50 transition-colors">
      <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <span class="text-[13px] font-bold text-text-muted">Page {{poolsPage}} of {{Math.ceil(poolsTotal /
      poolsLimit)}}</span>
    <button (click)="nextPoolsPage()" [disabled]="poolsPage * poolsLimit >= poolsTotal"
      class="w-10 h-10 rounded-xl bg-[#111] border border-white/10 flex items-center justify-center text-white disabled:opacity-50 disabled:cursor-not-allowed hover:border-gold/50 transition-colors">
      <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
  }
  }

  <!-- How Staking Works -->
  <div
    class="bg-[#0c0c0c]/60 border border-white/[0.05] shadow-[0_12px_45px_rgba(0,0,0,0.4)] rounded-[24px] p-10 backdrop-blur-md">
    <div class="text-center mb-10 relative">
      <div class="absolute inset-0 flex items-center justify-center opacity-10">
        <div class="w-full h-px bg-gradient-to-r from-transparent via-white to-transparent"></div>
      </div>
      <h3 class="text-[15px] font-bold text-white relative inline-block bg-[#0c0c0c] px-4">How Staking Works</h3>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-4 gap-8 relative">
      <!-- Connect Lines and Arrows for desktop -->
      <div
        class="hidden md:block absolute top-[28px] left-[12.5%] right-[12.5%] h-[1px] border-t border-dashed border-white/20 z-0">
      </div>

      <div class="hidden md:block absolute top-[28px] left-[25%] -translate-x-1/2 -translate-y-1/2 z-0"><svg
          class="w-4 h-4 text-white/40" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg></div>
      <div class="hidden md:block absolute top-[28px] left-[50%] -translate-x-1/2 -translate-y-1/2 z-0"><svg
          class="w-4 h-4 text-white/40" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg></div>
      <div class="hidden md:block absolute top-[28px] left-[75%] -translate-x-1/2 -translate-y-1/2 z-0"><svg
          class="w-4 h-4 text-white/40" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg></div>

      <!-- Step 1 -->
      <div class="flex flex-col items-center text-center relative z-10">
        <div
          class="w-14 h-14 rounded-full border border-gold/30 bg-[#050505] flex items-center justify-center text-gold mb-5 shadow-[0_0_20px_rgba(245,183,59,0.1)]">
          <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
          </svg>
        </div>
        <h4 class="text-[14.5px] font-bold text-white mb-2">1. Connect Wallet</h4>
        <p class="text-[12.5px] text-text-muted leading-relaxed max-w-[200px]">Connect your wallet to get started</p>
      </div>

      <!-- Step 2 -->
      <div class="flex flex-col items-center text-center relative z-10">
        <div
          class="w-14 h-14 rounded-full border border-gold/30 bg-[#050505] flex items-center justify-center text-gold mb-5 shadow-[0_0_20px_rgba(245,183,59,0.1)]">
          <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
          </svg>
        </div>
        <h4 class="text-[14.5px] font-bold text-white mb-2">2. Choose Pool</h4>
        <p class="text-[12.5px] text-text-muted leading-relaxed max-w-[200px]">Select a staking pool that suits you</p>
      </div>

      <!-- Step 3 -->
      <div class="flex flex-col items-center text-center relative z-10">
        <div
          class="w-14 h-14 rounded-full border border-gold/30 bg-[#050505] flex items-center justify-center text-gold mb-5 shadow-[0_0_20px_rgba(245,183,59,0.1)]">
          <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <h4 class="text-[14.5px] font-bold text-white mb-2">3. Stake Assets</h4>
        <p class="text-[12.5px] text-text-muted leading-relaxed max-w-[200px]">Stake your tokens to start earning
          rewards</p>
      </div>

      <!-- Step 4 -->
      <div class="flex flex-col items-center text-center relative z-10">
        <div
          class="w-14 h-14 rounded-full border border-gold/30 bg-[#050505] flex items-center justify-center text-gold mb-5 shadow-[0_0_20px_rgba(245,183,59,0.1)]">
          <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
          </svg>
        </div>
        <h4 class="text-[14.5px] font-bold text-white mb-2">4. Earn Rewards</h4>
        <p class="text-[12.5px] text-text-muted leading-relaxed max-w-[200px]">Earn passive rewards over time</p>
      </div>
    </div>
  </div>

</div>

<!-- Stake Modal -->
@if (stakeModalOpen && selectedPool) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-[#050505]/80 backdrop-blur-sm p-4 animate-fade-in">
  <div
    class="bg-[#0c0c0c] border border-white/[0.08] shadow-2xl rounded-[24px] w-full max-w-[420px] p-6 relative overflow-hidden animate-slide-up">
    <!-- Glow -->
    <div class="absolute -top-24 -left-24 w-48 h-48 bg-gold/10 rounded-full blur-[60px] pointer-events-none"></div>

    <div class="flex items-center justify-between mb-6 relative z-10">
      <h3 class="text-[18px] font-bold text-white flex items-center gap-2">
        Stake {{selectedPool.tokenName}}
      </h3>
      <button (click)="closeStakeModal()"
        class="w-8 h-8 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-text-muted hover:text-white transition-colors">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Amount Input -->
    <div class="mb-5 relative z-10">
      <div class="flex justify-between items-center mb-2">
        <label class="text-[12.5px] font-bold text-text-muted">Deposit Amount</label>
        <span class="text-[12px] font-medium text-text-muted cursor-pointer hover:text-white transition-colors" (click)="stakeAmount = selectedTokenBalance.toString()">Balance: {{selectedTokenBalance | number:'1.0-4'}}</span>
      </div>
      <div class="relative">
        <input type="number" [(ngModel)]="stakeAmount" placeholder="0.0"
          class="w-full bg-[#111] border border-white/10 rounded-xl py-3.5 pl-4 pr-16 text-[20px] font-black text-white focus:outline-none focus:border-gold/50 transition-colors">
        <div class="absolute right-4 top-1/2 -translate-y-1/2 flex items-center gap-2">
          <span class="text-[14px] font-bold text-text-muted">{{selectedPool.tokenName}}</span>
        </div>
      </div>
    </div>

    <!-- Lock Tiers -->
    <div class="mb-6 relative z-10" *ngIf="selectedPool.lockTiers?.length">
      <label class="text-[12.5px] font-bold text-text-muted mb-3 block">Select Lock Tier</label>
      <div class="grid grid-cols-3 gap-3">
        <div *ngFor="let tier of selectedPool.lockTiers; let i = index"
          (click)="selectedTier = i"
          [ngClass]="selectedTier === i ? 'border-gold bg-gold/10' : 'border-white/10 bg-[#111] hover:border-white/20'"
          class="border rounded-xl p-3 cursor-pointer transition-colors text-center">
          <div class="text-[13px] font-bold text-white mb-1">
            {{tier.duration === 0 ? 'Flexible' : (tier.duration / 86400) + ' Days'}}
          </div>
          <div class="text-[11px] text-gold font-bold">{{tier.apyBps / 100}}% APY</div>
        </div>
      </div>
    </div>

    <!-- Info Box -->
    <div class="bg-[#111]/50 border border-white/5 rounded-xl p-4 mb-6 relative z-10">
      <div class="flex justify-between items-center">
        <span class="text-[11.5px] text-text-muted">Estimated APY</span>
        <span class="text-[12.5px] font-bold text-[#20d489]">~{{selectedPool.lockTiers ? (selectedPool.lockTiers[selectedTier]?.apyBps / 100 || 0) : 0}}%</span>
      </div>
    </div>

    <button [disabled]="!!stakingStatus || !stakeAmount" (click)="deposit()"
      class="w-full btn-gold py-4 rounded-xl font-black text-[14px] tracking-widest relative z-10 disabled:opacity-50 disabled:cursor-not-allowed">
      {{stakingStatus ? stakingStatus : 'CONFIRM STAKE'}}
    </button>
  </div>
</div>
}